/* ------------------------------------------------------------------
   rt-events.js — fork do events.js do RedTrack, servido pelo tema.

   POR QUE ESTE FORK EXISTE
   O events.js original dispara um postback `type=viewcontent` a CADA
   carregamento de PDP. Dentro do RedTrack isso entra como conversao do tipo
   generico `conversion`: 89 registros num unico dia de teste, contra 2 compras
   reais. Isso suja a coluna de conversoes, o CPA e o ROAS de todo relatorio.

   E, com um pixel ligado a offer, uma conversao generica so' nao vira compra
   falsa no Meta porque o campo "Default event name" da integracao CAPI esta'
   preenchido com RT_Unclassified. Esse campo e' a unica coisa entre esse lixo e
   um Purchase fantasma. Depender de um campo de texto para nao inventar receita
   e' fragil demais: aqui a gente corta na origem.

   O QUE MUDOU EM RELACAO AO ORIGINAL — exatamente duas coisas:

   1. `viewcontent` NAO dispara mais o /postback.
      A escrita do `__clickid` nos atributos do carrinho CONTINUA acontecendo no
      viewcontent. Isso e' deliberado e nao pode mudar: e' o carregamento da PDP
      que grava o click id no carrinho, e e' esse atributo que o webhook do app
      le' para atribuir a compra. Tirar isso quebraria a atribuicao de receita.

   2. O hostname do tracker vem de `window.__RT_HOST`.
      O original deriva o host de `document.currentScript.src`. Servido pelo
      tema, esse src e' o CDN da Shopify, e os postbacks iriam para
      trycalmwave.com/postback em vez de track.trycalmwave.com/postback. O
      snippet `tracking-head.liquid` define __RT_HOST a partir do setting
      `rt_events_src`, entao o dominio continua vindo de um setting (secao 6) e
      nao fica cravado aqui. Se __RT_HOST faltar, cai no comportamento original.

   O QUE NAO MUDOU
   `addtocart` e `buynow` continuam disparando normalmente — sao eventos reais
   de funil, de volume baixo, e nao e' deles que vem o lixo.
   Purchase e InitiateCheckout nunca passaram por aqui: quem os emite e' o
   webhook server-side do app do RedTrack, lendo o `__clickid` do pedido.

   Ao atualizar o app do RedTrack, comparar este arquivo com
   https://track.trycalmwave.com/events.js e reaplicar as duas mudancas.
   Original forkado em 2026-08-22 (5269 chars).
   ------------------------------------------------------------------ */

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length >= 2) return parts.pop().split(";").shift();
}

function submitEvent(hostname, type) {
    var clickId = getCookie('rtkclickid-store');
    if (!clickId || clickId === 'undefined') {
        clickId = sessionStorage.getItem("rtkclickid");
    }
    if (!clickId || clickId === 'undefined') {
        setTimeout(function () {
            submitEvent(hostname, type);
        }, 1000);
        return;
    }
    console.log(type);

    /* MUDANCA 1: viewcontent nao gera postback. Ver o cabecalho. */
    if (type !== 'viewcontent') {
        var xhr = new XMLHttpRequest;
        xhr.open("GET", `${hostname}/postback?clickid=${clickId}&type=${type}&eventid=${clickId}`);
        xhr.send();
    }

    /* Intocado: e' aqui que a atribuicao da compra acontece. */
    if (type === 'viewcontent' || type === 'addtocart') {
        var xhr2 = new XMLHttpRequest;
        xhr2.open("POST", '/cart/update.js');
        xhr2.setRequestHeader("Content-Type", "application/json");
        xhr2.send(
            JSON.stringify({
                attributes: {
                    '__clickid': clickId,
                }
            })
        );
    }
}

function detectProductByMeta() {
    try {
        return meta && meta.product;
    } catch (e) {
        return false;
    }
}

function detectProductByCartForm() {
    return document.querySelector("form[action='/cart/add']");
}

var pathArray = document.currentScript.src.split('/');
var protocol = pathArray[0];
var host = pathArray[2];
/* MUDANCA 2: host do tracker via __RT_HOST, com fallback ao original. */
var hostname = window.__RT_HOST || (protocol + '//' + host);
var cartFormDetected = false;
var isProduct = false;
document.addEventListener("DOMContentLoaded", function () {
    if (detectProductByMeta() || detectProductByCartForm()) {
        isProduct = true;
    } else {
        var path = window.location.pathname;
        var potentialHandle = path.substring(path.lastIndexOf("/") + 1);
        var xhr = new XMLHttpRequest;
        xhr.onreadystatechange = function () {
            if (xhr.status == 200) {
                submitEvent(hostname, 'viewcontent');
            }
        };
        xhr.open("GET", `/products/${potentialHandle}.json`);
        xhr.send();
    }
    if (isProduct) {
        submitEvent(hostname, 'viewcontent');

        document.body.addEventListener('click', function (event) {
            if (event.target.className && event.target.className.toString().indexOf('shopify-payment-button__button') !== -1) {
                submitEvent(hostname, 'buynow');
            }
            ;
        });
    }

    var cartForms = document.querySelectorAll("form[action='/cart/add']");
    if (cartForms) {
        cartForms.forEach(function (cartForm) {
            cartForm.addEventListener("submit", function (e) {
                submitEvent(hostname, 'addtocart');
                cartFormDetected = true;
            });
        });
    }
});

(function () {
    var open = window.XMLHttpRequest.prototype.open;

    function openReplacement() {
        this.addEventListener("load", function () {
            if (this._url && this._url.indexOf('/products/') !== -1 && this._url.indexOf('view=ajax') !== -1) {
                submitEvent(hostname, 'viewcontent');

                setTimeout(function () {
                    var cartForms = document.querySelectorAll("form[action='/cart/add']");
                    if (cartForms) {
                        cartForms.forEach(function (cartForm) {
                            cartForm.addEventListener("submit", function (e) {
                                submitEvent(hostname, 'addtocart');
                                cartFormDetected = true;
                            });
                        });
                    }
                }, 2000);
            }
            if (
                [
                    `${window.location.origin}/cart/add.js`,
                ].includes((this._url ? this._url.split('?')[0] : this._url))
            ) {
                if (!cartFormDetected) {
                    submitEvent(hostname, 'addtocart');
                }
            }
        });
        return open.apply(this, arguments);
    }

    window.XMLHttpRequest.prototype.open = openReplacement;
})();

(function (ns, fetch) {
    if (typeof fetch !== 'function') return;

    ns.fetch = function () {
        var response = fetch.apply(this, arguments);

        response.then(res => {
            if ([
                `${window.location.origin}/cart/add.js`,
            ].includes((res.url ? res.url.split('?')[0] : res.url))) {
                res.clone().json().then(data => {
                    if (!cartFormDetected) {
                        submitEvent(hostname, 'addtocart');
                    }
                });
            }
        });

        return response;
    }

}(window, window.fetch))
